import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { GodLocalStorageComponent } from './god-local-storage.component';
import { Gt2PrimengModule } from '../../../modules/gt2-primeng.module';
import { AppRoutesName } from '../../../const/AppRoutesName';
import { MatListModule } from '@angular/material/list';
import { TranslateModule } from '@ngx-translate/core';
import { MatInputModule } from '@angular/material/input';
import { NgxPermissionsModule } from 'ngx-permissions';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { FuseDirectivesModule } from '../../../../../@fuse/directives/directives';
import { FusePipesModule } from '../../../../../@fuse/pipes/pipes.module';

const routes = [
  {
    path: ':shop_uuid/' + AppRoutesName.EN.GOD_LOCAL_STORAGE,
    component: GodLocalStorageComponent,
  },
  {
    path: ':shop_uuid/' + AppRoutesName.FR.GOD_LOCAL_STORAGE,
    component: GodLocalStorageComponent,
  },
];

@NgModule({
  declarations: [GodLocalStorageComponent],
  imports: [
    CommonModule,
    FormsModule,
    MatButtonModule,
    ReactiveFormsModule,
    FuseDirectivesModule,
    FusePipesModule,
    TranslateModule,
    MatInputModule,
    NgxPermissionsModule,
    Gt2PrimengModule,
    RouterModule.forChild(routes),
    MatListModule,
  ],
  exports: [GodLocalStorageComponent],
})
export class GodLocalStorageModule {}
